import NotAdmin from './NotAdmin';

export default NotAdmin;